import React from 'react';
import { SvgIcon } from '@material-ui/core';

const StartIcon = (props) => (
  <SvgIcon
    width="21.391"
    height="30.147"
    viewBox="0 0 21.391 30.147"
    {...props}
  >
    <path
      id="Tracé_3679"
      d="M27.02 9.8l17.912 6.826L31.9 23.792l-4.884 2.688z"
      transform="translate(-23.542 -6.999)"
    />
    <path
      id="Tracé_3680"
      d="M19.176 1.847c0-.639-.779-1.157-1.74-1.157S15.7 1.208 15.7 1.847a1.193 1.193 0 0 0 .909 1.017v27.973h1.659V2.864a1.194 1.194 0 0 0 .908-1.017z"
      transform="translate(-15.697 -0.69)"
    />
  </SvgIcon>
);

export default StartIcon;
